import { atomWithKey as atom } from "./atomWithKey";
import { ITrip } from "../Types/Interface/ITrip";

export interface ShuttleBookedOffer {
  id: string;
  admissions: Array<{
    price?: {
      amount: number;
    };
  }>;
}

export interface ShuttleBookedOffersData {
  bookedOffers: ShuttleBookedOffer[];
  /**
   * The trips of the SAME booking read these offers came from.
   *
   * Load-bearing, not convenience: an offer carries only `coveredTripId`, so
   * every endpoint, time and service number is resolved by looking that id up
   * in the booking's trips. Resolving it against bookingResponseAtom instead
   * reads a snapshot that can predate the shuttle — after an F5 mid-checkout it
   * is the localStorage copy written before the add — and the lookup then misses,
   * yielding an entry with empty origin/destination refs that maps to no side at
   * all. The shuttle silently reverts to a purchasable row and the next add
   * books a second offer (measured live 2026-08-07).
   */
  trips?: ITrip[];
  /**
   * The passengers of that same read. Admissions reference booking passenger
   * IDs and every consumer keys off `externalRef`, so the mapping has to come
   * from the same snapshot as the offers — for the reason `trips` does.
   */
  passengers?: { id: string; externalRef: string }[];
  totalPrice: number;
  lastUpdated: number;
  hasOutboundShuttle?: boolean;
  hasInboundShuttle?: boolean;
}

export const shuttleBookedOffersAtom = atom<ShuttleBookedOffersData | null>({
  key: "shuttleBookedOffersAtom",
  default: null,
});

export const isAddShuttleFlowAtom = atom<boolean>({
    key: "isAddShuttleFlowAtom",
    default: false
})
